import { Injectable } from '@angular/core';
import { Observable, Observer, Subscriber, TeardownLogic } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MulticastObserverFactoryService {
  create<T>(loadData: (observer?: Observer<T>) => void): Observable<T> {
    return new Observable<T>(this.multicastSequenceSubscriber(loadData));
  }

  /**
   * allows multiple subscriptions to async data but only causes one api call and inform all subscribers
   */
  private multicastSequenceSubscriber<T>(
    loadData: (observer: Observer<T>) => void
  ): (subscriber: Subscriber<T>) => TeardownLogic {
    // Keep track of each observer (one for every active subscription)
    const observers: Observer<T>[] = [];
    let loaded = false;
    // Return the subscriber function (runs when subscribe()
    // function is invoked
    return (observer: Observer<T>) => {
      observers.push(observer);
      // When this is the first subscription, load the data and push an update
      if (observers.length === 1 || loaded) {
        loadData({
          next(val) {
            loaded = true;
            // Iterate through observers and notify all subscriptions
            // make a local copy to not hop over sliced elements while iterating
            observers.slice(0).forEach(obs => obs.next(val));
          },
          error(error) {
            observers.slice(0).forEach(obs => obs.error(error));
          },
          complete() {
            // Notify all complete callbacks
            observers.slice(0).forEach(obs => obs.complete());
          }
        });
      }

      return {
        unsubscribe() {
          // Remove from the observers array so it's no longer notified
          const index = observers.indexOf(observer);
          if (index >= 0) {
            observers.splice(index, 1);
          }
        }
      };
    };
  }
}
